module.exports = __webpack_public_path__ + "img/MGH-Gaien-9-2440x1172.301ef765.jpg";